export const legendView = `bg-white top-0 left-0 -translate-y-1/2 leading-[0.938vw] text-inputBorder ml-[0.729vw] px-[0.104vw] text-[0.625vw] md:ml-[1.823vw] md:px-[0.26vw] md:text-[1.563vw] md:leading-[2.344vw]
xs:ml-[3.733vw] xs:px-[0.533vw] xs:text-[3.2vw] xs:leading-[4.8vw]`;
export const placeholderView = `top-[0.677vw] left-[0.729vw] text-[0.834vw] leading-[1.25vw] md:text-[2.083vw]
md:leading-[3.125vw] xs:text-[4.267vw] xs:leading-[6.4vw] text-midGray
md:left-[1.823vw] md:top-[1.563vw] xs:left-[3.733vw] xs:top-[3.2vw]`;
